import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useTime } from '../../../hooks/useTime'
import { useHook } from '../../../lenteHooks'
import { OverviewItem } from '../../overview/OverviewItem'

export const BirthOrDeathDate = () => {
  const translate = useTranslate()
  const { data: time } = useTime()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )({
    tenantId,
    personId: ownerId,
  })

  const { hint, iconName, label } = dateUtils.isValidDate(
    personVersion?.deathDate,
  )
    ? {
        hint: translate('birthOrDeathDate.deathdate'),
        iconName: 'Tomb' as const,
        label: dateUtils.formatDateAndAge({
          startDate: personVersion.birthDate,
          endDate: personVersion.deathDate,
          displayDate: 'endDate',
          translatedYear: translate('age.year'),
          translatedMonth: translate('age.month'),
        }),
      }
    : {
        hint: translate('birthOrDeathDate.birthdate'),
        iconName: 'Cake' as const,
        label: dateUtils.formatDateAndAge({
          startDate: personVersion?.birthDate,
          endDate: time,
          translatedYear: translate('age.year'),
          translatedMonth: translate('age.month'),
        }),
      }

  return (
    personVersion?.birthDate && (
      <OverviewItem title={hint} iconName={iconName}>
        {label}
      </OverviewItem>
    )
  )
}
